<template>
  <div class="interest_overview">
    <div v-if="detailList && detailList.length" class="overview">
      <section class="main">
        <dl class="results">
          <dt>
            保单年度 <span>{{ dragValue + curProductInterestData.startPolicyNo }}</span> 年 被保人 <span>{{ params.insuredAge + curProductInterestData.startIndex + dragValue + 1 }}</span> 岁时
          </dt>
          <dd
            v-for="o in detailList"
            :key="o.key"
            class="result"
          >
            <div class="left" @click="onClickLabel">
              <i v-if="o.detail" class="iconfont icon-common_problem" />
              <span>{{ o.name }}：</span>
            </div>
            <div class="right">
              <span class="highlight">
                {{ getCurrentValue(o) }}
              </span>
              <span>
                {{ getCurrentUnit(o) }}
              </span>
              <span v-if="o.details && o.details[dragValue]" class="purpose">
                {{ o.details[dragValue] }}
              </span>
            </div>
          </dd>
        </dl>
      </section>
    </div>
    <div class="drag" :class="{ 'has_insured2': hasInsured2 }">
      <div class="left" @click.stop.prevent="minusHandler">
        <i class="iconfont icon-reduce_b" />
      </div>
      <div class="middle">
        <div class="runway_wrapper" @click.stop.prevent="clickRunwayHandler">
          <div id="runway" class="runway">
            <i class="iconfont icon-arrow_down arrow" :style="{ left: `${dragBarData.width}px` }" />
            <div class="bar" :style="{ width: `${dragBarData.width}px`}" />
            <div
              class="drag_handle"
              :style="{
                transform: `translate3d(${dragBarData.width}px, -50%, 0)`
              }"
              @click.stop.prevent="onClickDragButton"
              @touchstart.prevent="onClickDragButton"
              @touchmove.prevent="moveHandler"
              @touchend.prevent
            >
              <div class="tooltip">
                {{ dragHandlerStr }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="right" @click.stop.prevent="plusHandler">
        <i class="iconfont icon-dd_add" />
      </div>
    </div>
    <p class="tips">
      拖动按钮，查看不同年龄段保单利益
    </p>
    <interest-chart
      :cur-product-interest-data="curProductInterestData"
      :filter-interest-detail-data="filterInterestDetailData"
      :params="params"
      @openExplain="$emit('openExplain')"
      @update="data => $emit('update', data)"
    />
  </div>
</template>
<script>
import { get as _get } from 'lodash'
import InterestChart from './interest-chart.vue'

export default {
  components: {
    InterestChart
  },
  props: {
    formData: {
      type: Object,
      default: () => ({})
    },
    curProductInterestData: {
      type: Object,
      default: () => ({})
    },
    filterInterestDetailData: {
      type: Array,
      default: () => []
    },
    params: {
      type: Object,
      default: () => ({})
    },
  },
  data () {
    return {
      dragBarData: {
        maxValue: 0,
        runwayWidth: 0,
        runwayX: 0,
        width: 0
      }
    }
  },
  computed: {
    dragValue () {
      return this.formData.formValues.dragValue
    },
    detailList () {
      return (this.filterInterestDetailData || []).filter(e => e.key !== 'remark')
    },
    hasInsured2 () {
      return typeof this.params.insured2Age === 'number'
    },
    dragHandlerStr () {
      const { params, curProductInterestData, dragValue, hasInsured2 } = this
      const str = [
        `${params.insuredAge + curProductInterestData.startIndex + dragValue + 1}`,
        hasInsured2 ? `/${params.insured2Age + curProductInterestData.startIndex + dragValue + 1}` : '',
        '岁'
      ].join('')
      return str
    }
  },
  watch: {
    filterInterestDetailData: {
      deep: true,
      immediate: true,
      handler (v) {
        this.initDragBar()
      }
    },
    dragValue: {
      immediate: true,
      handler (v) {
        const { dragBarData } = this
        if (dragBarData.runwayWidth) {
          dragBarData.width = Math.floor(v / dragBarData.maxValue * dragBarData.runwayWidth)
        }
      }
    }
  },
  mounted () {
    this.initDragBar()
  },
  methods: {
    getCurrentValue (item) {
      const { curProductInterestData, params, dragValue } = this
      if (['irr_value', 'single_value'].includes(item.key)) {
        if (dragValue + (params && params.insuredAge ? params.insuredAge : 0) + curProductInterestData.startPolicyNo <= params.period) {
          return '交费期'
        }
        return item.values[dragValue] ? item.values[dragValue].toFixed(2) : '-'
      }
      if (['policy_cash_grow_rate'].includes(item.key)) {
        return item.values[dragValue] ? item.values[dragValue].toFixed(2) : '-'
      }
      return item.values[dragValue] || 0
    },
    getCurrentUnit (item) {
      const { curProductInterestData, params, dragValue } = this
      if (['irr_value', 'single_value'].includes(item.key)) {
        if (dragValue + curProductInterestData.startPolicyNo <= params.period) {
          return ''
        }
        return item.values[dragValue] ? '%' : ''
      }
      if (['policy_cash_grow_rate'].includes(item.key)) {
        return item.values[dragValue] ? '%' : ''
      }
      return '元'
    },
    initDragBar () {
      const { detailList, dragValue, dragBarData } = this
      const runwayDom = document.querySelector('#runway')
      if (!detailList || !runwayDom) {
        return
      }
      dragBarData.maxValue = detailList.reduce((a, b) => Math.max(b.values ? b.values.length : 0, a), 0) - 1
      dragBarData.runwayX = runwayDom.getBoundingClientRect().x
      dragBarData.runwayWidth = runwayDom.offsetWidth
      dragBarData.width = Math.floor(dragValue / dragBarData.maxValue * dragBarData.runwayWidth)

      const _formValues = _get(this, 'formData.formValues')
      if (dragBarData.maxValue > 0 && _formValues.dragValue > dragBarData.maxValue) {
        _formValues.dragValue = 0
      }
    },
    minusHandler () {
      this.$emit('update', {
        dragValue: Math.max(0, this.dragValue - 1)
      })
    },
    plusHandler () {
      this.$emit('update', {
        dragValue: Math.min(this.dragBarData.maxValue, this.dragValue + 1)
      })
    },
    clickRunwayHandler (e) {
      this.$emit('update', {
        dragValue: Math.floor(e.offsetX / this.dragBarData.runwayWidth * this.dragBarData.maxValue)
      })
    },
    moveHandler (e) {
      const { dragBarData } = this
      let touch = e.targetTouches[0]
      let distance = touch.clientX - dragBarData.runwayX
      if (distance < 0) {
        distance = 0
      }
      if (distance > dragBarData.runwayWidth) {
        distance = dragBarData.runwayWidth
      }
      this.$emit('update', {
        dragValue: Math.floor(distance / dragBarData.runwayWidth * dragBarData.maxValue)
      })
    },
    onClickDragButton () {
      window.WeiyiStatSDK.submit('lyglnftd')
    },
    onClickLabel () {
      this.$emit('openExplain')
    }
  }
}
</script>
<style>
@import './interest-overview.css';
</style>
